module.exports = __webpack_public_path__ + "static/media/seal work3.dcedae8b.png";